import { useMutation } from '@tanstack/react-query';

import { post } from 'services/api';

/**
 * Fires the forgot-password request for `email`.
 *
 * KNOWN DEBT (data-fetching mode 8 — silent swallow): only `mutate` is exposed
 * and the mutation declares no `onError`, so a failed request surfaces nothing
 * to the caller — the current consumer (`ResetModal`, red zone) closes the modal
 * on click regardless of outcome. Surfacing the failure requires returning the
 * full mutation object (`isError`/`error`) plus a consumer change; deferred while
 * the only consumer is red zone. Any green-zone consumer must NOT copy the
 * fire-and-forget pattern — read the error state and render a retryable surface.
 */
export const useResetPassword = (email?: string) => {
	const { mutate } = useMutation({
		mutationFn: () => {
			return post('/public/users/forgot-password', { email });
		},
	});
	return mutate;
};
